import script from "./courseItem.vue?vue&type=script&setup=true&name=courseItem&lang=js"
export * from "./courseItem.vue?vue&type=script&setup=true&name=courseItem&lang=js"

import "./courseItem.vue?vue&type=style&index=0&id=81d90896&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81d90896"]])

export default __exports__